import { DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomAccountSelect, CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { TableBody, TableView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { SVGAsset } from "res";

/**
 * @function TASPositivePayImportChecksUsingTemplateDesktopView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Add Check desktop content view.
 */
export default function TASPositivePayImportChecksUsingTemplateDesktopView(props) {
      const { data, ui, onDesktopChange, onDeleteClick, onSubmitClick, getPageErrors } = useStateManager();
      const checkForms = data.checkForms;
      const hasAccountErrors = getPageErrors("account").length > 0;

      const typeItems = data.itemTypeCodes.reduce((acc, item) => {
        acc.push(
          <CustomSelectItem key={ item.id } value={ item.itemTypeMappingValue }
          dataPoint={ `TAS_Positive_Pay_Import_Checks_Using_Template_Desktop_Type_Select_Option_${ item.id }` }>
            { item.itemTypeMapping }
          </CustomSelectItem>
        );
        return acc;
      }, []);

      const rows = checkForms.reduce((acc, item, index) => {
        const amount = item.amount ? item.amount.amount : undefined;
        const uiItem = ui.checkForms.filter(uiItem => uiItem.id === item.id)[0];
        const accountError = item.account ? false : true;
        const accountClasses = accountError ? { className: "select-error"} : {};
        
        acc.push( 
          <tr key={ item.id } className="table-item-container">
            <td className="table-item-view">
              { index + 1 }
            </td>
            <td className="table-item-view account">
              <CustomAccountSelect { ...accountClasses} value={ item.account } accounts={ data.accounts } active={ uiItem.account.isActive }
              dataPoint={ `TAS_Positive_Pay_Import_Checks_Using_Template_Desktop_Account_Select_${ item.id }` }
              onChange={ onDesktopChange(item.id, "account") }/>
            </td>
            <td className="table-item-view">
            <DateSelect enablePast={ true } 
              value={ item.issuedDate } active={ uiItem.issuedDate.isActive } onChange={ onDesktopChange(item.id, "issuedDate") }/>
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.checkNumber }
               onChange={ onDesktopChange(item.id, "checkNumber") } />
            </td>
            <td className="table-item-view">
              <UIAmountInput className="amount-field" value={ amount } showClearButton={ false }
               onChange={ onDesktopChange(item.id, "amount") } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.payee }
               onChange={ onDesktopChange(item.id, "payee") } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.referenceNumber } dataPoint={ `TAS_Positive_Pay_Add_Checks_Desktop_Reference_Number_Input_${ item.id }` }
               onChange={ onDesktopChange(item.id, "referenceNumber") } />
            </td>
            <td className="table-item-view type">
              <CustomSelect value={ item.type } active={ uiItem.type.isActive }
               onChange={ onDesktopChange(item.id, "type") }>
                  { typeItems }
              </CustomSelect>
            </td>
            
            <td className="table-item-view">
            <DisabledPrompt>
              <span className="clickable" data-point={ `TAS_Positive_Pay_Add_Checks_Desktop_Close_Button_${ item.id }` } onClick={ onDeleteClick(item.id) }>
                <SVGAsset id="cancel" />
              </span>
            </DisabledPrompt>
            </td> 
            
          </tr>
        );
        return acc;
      }, []);

    return (
        <div className="flex-container flex-vertical table-view-container show-on-desktop">
        <TableView className="tas-positive-pay-import-checks-using-template-table">
            <thead className="table-column-container">
            <tr>
                <th className="text-left table-column-view">Row</th>
                <th className="text-left table-column-view">Account</th>
                <th className="text-left table-column-view">Issued Date</th>
                <th className="text-left table-column-view">Check Number</th>
                <th className="text-left table-column-view">Amount</th>
                <th className="text-left table-column-view">Payee (Optional)</th>
                <th className="text-left table-column-view">Reference Number (Optional)</th>
                <th className="text-left table-column-view">Type</th>
                <th className="text-left table-column-view"></th>
            </tr>
            </thead>
            <TableBody>{ rows } </TableBody>
        </TableView>
        { hasAccountErrors
        && <div className="error-alert-info-container">
              <SVGAsset id="AlertTriangleIcon" className="" />
              <span>{ `Required field(s) can't be blank.` }</span>
          </div>
        }
        </div>
    );
}